/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserAccountFromJSON, UserAccountToJSON, } from "./UserAccount";
/**
 * Check if a given object implements the LoginResponse interface.
 */
export function instanceOfLoginResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "userAccount" in value;
    return isInstance;
}
export function LoginResponseFromJSON(json) {
    return LoginResponseFromJSONTyped(json, false);
}
export function LoginResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        userAccount: UserAccountFromJSON(json.userAccount),
    };
}
export function LoginResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        userAccount: UserAccountToJSON(value.userAccount),
    };
}
